import BaseModelService from '../../base/base_model_service';
import Device from '../../utils/device/device';


/**
 *
 *
 */
class HybridVersionHandlerModel extends BaseModelService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'HybridVersionHandlerModel';


    /**
     *
     * @param params
     */
    init(params) {
        if (params) {
            this
                ._setBlockMinVersionIOS(params.blockMinVersionIOS)
                ._setBlockMinVersionAndroid(params.blockMinVersionAndroid)
                ._setMessageMinVersionIOS(params.messageMinVersionIOS)
                ._setMessageMinVersionAndroid(params.messageMinVersionAndroid)
                ._setAppStoreLink(params.appStoreLink)
                ._setGooglePlayLink(params.googlePlayLink)
        }
    }

    /**
     * set app store link
     * @private
     */
    _setAppStoreLink(appStoreLink) {
        this.appStoreLink = appStoreLink;
        return this;
    }

    /**
     * set google play link
     * @private
     */
    _setGooglePlayLink(googlePlayLink) {
        this.googlePlayLink = googlePlayLink;
        return this;
    }

    /** This param is to block the screen when the user Hybrid version is low then the min version for IOS
     * @param blockMinVersionIOS
     * @returns {HybridServiceModel}
     * @private
     */
    _setBlockMinVersionIOS(blockMinVersionIOS) {
        this._blockMinVersionIOS = blockMinVersionIOS;
        return this;
    }

    /**
     * This param is to block the screen when the user Hybrid version is low then the min version for Android
     * @param blockMinVersionAndroid
     * @returns {HybridServiceModel}
     * @private
     */
    _setBlockMinVersionAndroid(blockMinVersionAndroid) {
        this._blockMinVersionAndroid = blockMinVersionAndroid;
        return this;
    }

    /**
     * This param is to show message when the user Hybrid version is low then the min version for IOS
     * @param messageMinVersionIOS
     * @returns {HybridServiceModel}
     * @private
     */
    _setMessageMinVersionIOS(messageMinVersionIOS) {
        this._messageMinVersionIOS = messageMinVersionIOS;
        return this;
    }

    /**
     * This param is to show message when the user Hybrid version is low then the min version for Android
     * @param messageMinVersionAndroid
     * @returns {HybridServiceModel}
     * @private
     */
    _setMessageMinVersionAndroid(messageMinVersionAndroid) {
        this._messageMinVersionAndroid = messageMinVersionAndroid;
        return this;
    }

    /**
     * return the min version message for your device type(IOS/Android)
     * @returns {*}
     */
    getMessageMinVersion() {
        return Device.os.isIOS ? this._messageMinVersionIOS : this._messageMinVersionAndroid;
    }

    /**
     * return the min version block for your device type(IOS/Android)
     * @returns {*}
     */
    getBlockMinVersion() {
        return Device.os.isIOS ? this._blockMinVersionIOS : this._blockMinVersionAndroid;
    }

    /**
     * get google play/ app store link according to android/ios device
     * @private
     */
    getApplicationStore() {
        return Device.os.isIOS ? this.appStoreLink : this.googlePlayLink;
    }
}

export default HybridVersionHandlerModel;